// src/components/Layout.jsx
import { useLocation, Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import "./Layout.scss";

const Layout = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(null);
    const hideSidebarPaths = ["/", "/register", "/set-nickname"];

    useEffect(() => {
        const token = localStorage.getItem("token");
        // 토큰 생성 시간을 관리하는 로직이 Login.jsx에 없으므로, 우선 토큰 유무만으로 인증 상태를 판단합니다.
        // const tokenCreated = localStorage.getItem("token_created_at");
        // const tokenExpiry = 60 * 60 * 1000; // 1 hour

        // if (token && tokenCreated && Date.now() - parseInt(tokenCreated) > tokenExpiry) {
        //     localStorage.removeItem("token");
        //     localStorage.removeItem("token_created_at");
        //     localStorage.removeItem("userId");
        //     setIsAuthenticated(false);
        //     navigate('/login'); // 토큰 만료 시 로그인 페이지로 이동
        // } else {
        //     setIsAuthenticated(!!token);
        // }
        
        setIsAuthenticated(!!token);

    }, [location, navigate]);

    if (isAuthenticated === null) return null; // 인증 상태 확인 전까지 렌더링 방지

    return (
        <div className="layout">
            {!hideSidebarPaths.includes(location.pathname) && isAuthenticated && <Sidebar />}
            <div className="content">
                <Outlet />
            </div>
        </div>
    );
};

export default Layout;